//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
import { logToSentry } from "utils/networkErrorUtils";
import * as Actions from './actions';
import { handleListUserClasses } from 'store/userClasses/thunks';
import { shouldUseDeepLinking, getDeepLinkInfo, clearDeepLinkInfo } from 'utils/deepLinkHelper';

export const handeleCanvasCode = async (code,auth_id,domain) => {
  try {
    return apis.post("canvas", "/codeVerify", {
      body: {
        code: code,
        redirect_uri: window.location.origin,
        auth_id:auth_id,
        domain
      }
    })
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'verifying canvas code',
                error,
                module: 'CANVAS',
                operation: 'VALIDATE_CLASS_CLASS'
            });
    }
    return null;
  }
  

};
export const handleCheckUserLti = async (user_id, auth_url) => {
  try {
    return apis.post("canvas", "/check_user_lti", {
      body: {
        user_id,
        auth_url
      }
    })
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'checking user lti',
                error,
                module: 'CANVAS',
                operation: 'CREATE_USER_LESSON'
            });
    }
    return null;
  }
};
export const handleCheckUserAuthOnLti = async (id_token, target_uri) => {
  try {
    return apis.post("canvas", "/check_id_token", {
      body: {
        id_token,
        target_uri
      }
    })
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'checking user auth on lti',
                error,
                module: 'CANVAS',
                operation: 'CREATE_USER_ACTIVITY_ORGANIZATION_LESSON'
            });
    }
    return null;
  }
};
export const handeleCanvasUserLogin = async (access_code, global_id , auth_id , user_info) => {
  try {
    return apis.post("canvas", "/handleUser", {
      body: {
        "access_token": access_code,
        "global_id": global_id,
        auth_id,
        user_info
      }
    })
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'handling canvas user login',
                error,
                module: 'CANVAS',
                operation: 'HANDLE_CLASS_USER_LESSON'
            });
    }
    return null;
  }


};
export const handeleCanvasUserClasses = async (access_code,canvas_id,auth_id) => {
  try {
    return apis.post("canvas", "/handleUserCourses", {
      body: {
        "access_token": access_code,
        canvas_id,
        auth_id
      }
    })
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'handling canvas user classes',
                error,
                module: 'CANVAS',
                operation: 'HANDLE_CLASS_USER_CLASS'
            });
    }
    return null;
  }
};
export const handeleCanvasClassUsers = async (canvas_id,auth_id,class_id) => {
  try {
    return apis.post("canvas", "/handleClassStudents", {
      body: {
        canvas_id,
        auth_id,
        class_id
      }
    })
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'handling canvas class users',
                error,
                module: 'CANVAS',
                operation: 'HANDLE_CLASS_CLASS_USER'
            });
    }
    return null;
  }
};
export const handleListDistrictAuth =  () => async (dispatch) => {
  try {
    const result = await   apis.get("canvas", "/list_district", {})
    dispatch(Actions.setDistrictAuth(result))
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'listing district auth',
                error,
                module: 'CANVAS',
                operation: 'LIST_DEBATE_ACTIVITY'
            });
    }
    return null;
  }
  

};

// "assignments": [
//   {
//     "canvas_course_id": "2",
//     "due_date": "2023-07-20T05:59:00.000Z",
//     "weightage": "100",
//     "displayName": "assignment throgh lambda"
//   }
// ]
export const handleCreateCanvasAssignment = async (canvas_User_Id, assignments, auth_id) => {
  try {
    return apis.post("canvas", "/handleCreateAssignment", {
      body: {
        canvas_User_Id,
        assignments,
        auth_id
      }
    })
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'creating canvas assignment',
                error,
                module: 'CANVAS',
                operation: 'CREATE_CLASS_ACTIVITY'
            });
    }
    return null;
  }
};

export const handleEnqueueDedupeCanvasAssignments = async (canvas_User_Id, auth_id, class_id, scope = 'all', parent_org_id = null) => {
  try {
    return apis.post('canvas', '/enqueueDedupeCanvasAssignments', {
      body: {
        canvas_User_Id,
        auth_id,
        class_id,
        scope,
        parent_org_id,
      },
    });
  } catch (error) {
    if (error && error.message !== 'Network Error') {
      logToSentry({
        message: 'enqueue dedupe canvas assignments',
        error,
        module: 'CANVAS',
        operation: 'DEDUPE_CANVAS_ASSIGNMENTS',
      });
    }
    return null;
  }
};

export const handleCreateCanvasAssignmentDeepLink = (canvas_User_Id, assignments, auth_id, assignment_data) => async () => {
  try {
    if (shouldUseDeepLinking() && Array.isArray(assignments) && assignments.length > 0) {
      const deepLinkInfo = getDeepLinkInfo();
      const first = assignments[0];
      if (deepLinkInfo.id_token && first.internal_assignment_id) {
        const deepLinkResult = await handleDeepLinkReturn(
          deepLinkInfo.id_token,
          first.internal_assignment_id,
          first.displayName || first.title,
          assignment_data
        );
        
        if (deepLinkResult && deepLinkResult.success) {
          const { returnUrl, deepLinkResponse } = deepLinkResult.data;
          clearDeepLinkInfo();
          
          const expressBaseUrl = 'https://autologin.nosotrosonline.com';
          const returnEndpoint = `${expressBaseUrl}/api/lti/deep-link/return`;
          
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = returnEndpoint;
          form.style.display = 'none';
          
          const returnUrlInput = document.createElement('input');
          returnUrlInput.type = 'hidden';
          returnUrlInput.name = 'returnUrl';
          returnUrlInput.value = returnUrl;
          form.appendChild(returnUrlInput);
          
          const deepLinkResponseInput = document.createElement('input');
          deepLinkResponseInput.type = 'hidden';
          deepLinkResponseInput.name = 'deepLinkResponse';
          deepLinkResponseInput.value = JSON.stringify(deepLinkResponse);
          form.appendChild(deepLinkResponseInput);
          
          const stateInput = document.createElement('input');
          stateInput.type = 'hidden';
          stateInput.name = 'state';
          stateInput.value = deepLinkInfo.state || '';
          form.appendChild(stateInput);
          
          document.body.appendChild(form);
          form.submit();
          
          return {
            ...deepLinkResult,
            isDeepLinking: true,
            submitted: true
          };
        }
      }
    }
    
    return handleCreateCanvasAssignment(canvas_User_Id, assignments, auth_id);
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'creating canvas assignment (deep link)',
                error,
                module: 'CANVAS',
                operation: 'CREATE_CLASS_ACTIVITY'
            });
    }
    return null;
  }
};

export const handleCreatePendingActivity = (pendingActivityData) => async () => {
  try {
    const result = await apis.post('canvas', '/createPendingActivity', {
      body: pendingActivityData
    });
    return result;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
        message: 'creating pending activity',
        error,
        module: 'CANVAS',
        operation: 'CREATE_PENDING_ACTIVITY'
      });
    }
    return { success: false, error: error.message };
  }
};

export const handleSyncPendingActivity = async (pendingActivityId, canvasAssignmentId) => {
  try {
    return await apis.post('canvas', '/syncPendingActivity', {
      body: {
        pending_activity_id: pendingActivityId,
        canvas_assignment_id: canvasAssignmentId
      }
    });
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
        message: 'syncing pending activity',
        error,
        module: 'CANVAS',
        operation: 'SYNC_PENDING_ACTIVITY'
      });
    }
    return { success: false, error: error.message };
  }
};

export const handleListPendingActivities = async (userId, classId) => {
  try {
    return await apis.post('canvas', '/listPendingActivities', {
      body: {
        user_id: userId,
        class_id: classId
      }
    });
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
        message: 'listing pending activities',
        error,
        module: 'CANVAS',
        operation: 'LIST_PENDING_ACTIVITIES'
      });
    }
    return { success: false, error: error.message };
  }
};

export const handleDeepLinkReturn = async (id_token, internal_assignment_id, title, assignment_data) => {
  try {
    const data = await apis.post('canvas', `/handleDeepLinkReturn`, {
      body: {
        id_token,
        internal_assignment_id,
        title,
        assignment_data
      }
    });
    return data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
        message: 'handling deep link return',
        error,
        module: 'CANVAS',
        operation: 'HANDLE_DEEP_LINK_RETURN'
      });
    }
    return {
      status_code: 500,
      success: false,
      message: 'Error processing deep link return',
      error: error.message
    };
  }
}

// "assignments": [
//   {
//     "canvas_user_id": "109",
//     "canvas_course_id": "2",
//     "displayName": "assignment throgh lambda update",
//     "weightage": "100",
//     "due_date": "2023-07-22T05:59:00.000Z",
//     "canvas_id": "116"
//   }
// ]
export const handleUpdateCanvasAssignment = async (canvas_User_Id, assignments,auth_id) =>{
  try {
    return apis.put("canvas", "/handleUpdateAssignment", {
      body: {
        canvas_User_Id,
        assignments,
        auth_id
      }
    })
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'updating canvas assignment',
                error,
                module: 'CANVAS',
                operation: 'UPDATE_CLASS_ACTIVITY'
            });
    }
    return null;
  }
}
export const handleBulkUpdateCanvasAssignment = async (canvas_User_Id, assignments, auth_id) => {
  try {
    return apis.put("canvas", "/handleBulkUpdateAssignment", {
      body: {
        canvas_User_Id,
        assignments,
        auth_id
      }
    })
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'bulk updating canvas assignment',
                error,
                module: 'CANVAS',
                operation: 'UPDATE_CLASS_ACTIVITY'
            });
    }
    return null;
  }
}

// "assignments": [
//   {
//  assignment id =>     "canvas_id": "115",
//       "canvas_course_id": "2"
//   }
// ]
export const handleDeleteCanvasAssignment = async (canvas_User_Id, activityId, classAssignmentId = [], auth_id) =>{
  try {
    return apis.del("canvas", "/handleDeleteAssignment", {
      body: {
        canvas_User_Id,
        activityId,
        classAssignmentId,
        auth_id
      }
    })
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'deleting canvas assignment',
                error,
                module: 'CANVAS',
                operation: 'DELETE_CLASS_ACTIVITY'
            });
    }
    return null;
  }
}
// "assignments": {
//   "canvas_assignment_id":"116",
//   "course_id":"2",
//   "canvas_user_id":"5",
//   "grade":"10"
// }
export const handleUpdateCanvasGrade = async (canvas_User_Id, assignments,auth_id) =>{
  try {
    return apis.put("canvas", "/handleUpdateGrades", {
      body: {
        canvas_User_Id,
        assignments,
        auth_id
      }
    })
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'updating canvas grade',
                error,
                module: 'CANVAS',
                operation: 'UPDATE_CLASS_GROUP'
            });
    }
    return null;
  }
}
let canvasGradeQueue = []; 
let canvasDebounceTimer = null; 

export const handleUpdateCanvasGradeInBatch = async (canvas_teacher_id, assignments, auth_id) => {
    return new Promise((resolve) => {
      if(!assignments.canvas_assignment_id) return null;
        const hasValueIndex = canvasGradeQueue.findIndex((item) => item.canvas_assignment_id == assignments.canvas_assignment_id && item.canvas_user_id == assignments.canvas_user_id );
        if (hasValueIndex > -1) {
            canvasGradeQueue[hasValueIndex] = assignments;
        } else {
            canvasGradeQueue.push(assignments);
        }
        if (canvasDebounceTimer) {
            clearTimeout(canvasDebounceTimer);
        }
        canvasDebounceTimer = setTimeout(async () => {
            try {
                const response = await apis.post("canvas", "/updateGradesInBatch", {
                    body: {
                      canvas_teacher_id,
                      assignments:canvasGradeQueue,
                      auth_id
                    },
                });
                canvasGradeQueue = [];
                resolve(response); 
                return response;
            } catch (error) {
              if (error && error.message != "Network Error") {
                logToSentry({
                message: 'updating Canvas grades in batch',
                error,
                module: 'CANVAS',
                operation: 'UPDATE_CLASS_GROUP_INSTRUCTION_BOOK'
            });
              }
                console.log("Error updating Canvas grades in batch:", error);
                resolve(null); 
                return null;
            }
        }, 4000);
    });
};
export const handleSyncGrade = async (canvas_User_Id, course_id, section_id ,auth_id) =>{
  try {
    return apis.post("canvas", "/scheduleGradeSync", {
      body: {
        canvas_User_Id,
        course_id,
        auth_id,
        section_id
      }
    })
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'syncing grade',
                error,
                module: 'CANVAS',
                operation: 'SET_GROUP'
            });
    }
    return null;
  }
}
export const handleSyncAssignment = async (canvas_User_Id, course_id , section_id,auth_id) =>{
  try {
    return apis.post("canvas", "/syncClassAssignment", {
      body: {
        canvas_User_Id,
        course_id,
        section_id,
        auth_id
      }
    })
  } catch (error) {
    console.log(error, "rr");
    logToSentry({
        message: 'Error during Canvas sync assignment',
        error,
        module: 'CANVAS',
        operation: 'SYNC_ASSIGNMENT'
    });
    return null;
  }
}
export const handleSyncClassGradeToCanvas = async (classId,teacherId) =>{
  try {
    return apis.post("canvas", "/sync_to_canvas_class_grade", {
      body: {
        classId,teacherId
      }
    })
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
        message: 'Error during Canvas sync assignment',
        error,
        module: 'CANVAS',
        operation: 'SYNC_ASSIGNMENT'
    });
    }
    return null;
  }
}

// "assignments": {
//   "canvas_assignment_id":"116",
//   "course_id":"2",
//   "canvas_user_id":"5",
//   "status": 1 1 for excuse and 3 for missing
// }
export const handleUpdateCanvasStatus = async (canvas_User_Id, assignments,auth_id) =>{
  try {
    return apis.put("canvas", "/assignmentSubmissionStatusUpdate", {
      body: {
        canvas_User_Id,
        assignments,
        auth_id
      }
    })
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'updating canvas status',
                error,
                module: 'CANVAS',
                operation: 'UPDATE_CLASS_STUDENT'
            });
    }
    return null;
  }
}
/*
canvas_assignment_id 
course_id
*/
export const handleCreateCanvaSubmissions = async (canvas_user_id, assignments,auth_id) =>{
  try {
    return apis.post("canvas", "/handleCreateSubmissions", {
      body: {
        canvas_user_id, assignments, auth_id
      }
    })
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'creating canvas submissions',
                error,
                module: 'CANVAS',
                operation: 'CREATE_CLASS_STUDENT'
            });
    }
    return null;
  }
}
export const handleListCanvasAssignmentCat = (canvas_user_Id, course_id, auth_id) => async (dispatch) => {
    try {
      const categ = await apis.post("canvas", "/getWeightageCategoryByClass", {
        body: {
          canvas_user_Id: canvas_user_Id,
          auth_id: auth_id,
          course_id: course_id,
        },
      });
      if(categ&&!categ.error){
        dispatch(Actions.setCanvasAssignmentsCategory(categ))
      }
      return categ;
    } catch (error) {
      if (error && error.message != "Network Error") {
        logToSentry({
                message: 'listing canvas assignment category',
                error,
                module: 'CANVAS',
                operation: 'LIST_CLASS_ACTIVITY_CLASS'
            });
      }
      return null;
    }
  };

  export const handleUserByCanvasName = async (name) => {
    if(typeof name!="string") return [];
    try {
        const user = await apis.post("canvas", `/listUserByName`,{
          body:{
            title: name
          }
        })
        return user;
  
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing user by canvas name',
                error,
                module: 'CANVAS',
                operation: 'LIST_USER_BOOK_CLASS_NOTE'
            });
        }
        return ({ error: true });
    }
  }
  export const handleGetUserInfoById = async (canvas_id,auth_id) => {
    if(!canvas_id||!auth_id) return [];
    try {

        const user = await apis.post("canvas", `/getUserInfoById`,{
          body:{
            canvas_id,auth_id
          }
        })
        return user;
  
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting user info by canvas id',
                error,
                module: 'CANVAS',
                operation: 'GET_USER_INSTRUCTION_BOOK_CLASS_INSTRUCTION'
            });
        }
        return ({ error: true });
    }
  }
export const getCanvasKeyInfo = async (canvas_id, orgId) => {
  if (!canvas_id || !orgId) return {};
  try {

    const data = await apis.post("canvas", `/getKeyInfo`, {
      body: {
        canvas_id, orgId
      }
    })
    return data;

  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'getting canvas key info',
                error,
                module: 'CANVAS',
                operation: 'GET_CLASS_KEYSTORE_INSTRUCTION'
            });
    }
    return {};
  }
}
export const updateCanvasKeyInfo = async (config) => {
  if (!config) return {};
  try {
    const data = await apis.post("canvas", `/update_key_info`, {
      body: {
        config
      }
    })
    return data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'updating canvas key info',
                error,
                module: 'CANVAS',
                operation: 'UPDATE_CLASS_KEYSTORE_INSTRUCTION'
            });
    }
    return {};
  }
}

export const handleListCanvasKeys = async () => {
  try {
      const data = await apis.get('canvas', `/list_keys`);
      return data;
  } catch (error) {
      if (error && error.message != "Network Error") {
          logToSentry({
                message: 'listing canvas keys',
                error,
                module: 'CANVAS',
                operation: 'LIST_CLASS_KEYSTORE'
            });
      }
      return {}
  }
}
export const handleSyncTOCanvas = async (canvas_user_id, auth_id, assignment_id) => {
  try {
    const data = await apis.post('canvas', `/sync_assignment_grade_to_canvas`, {
      body: {
        "canvas_user_id": canvas_user_id,
        "auth_id": auth_id,
        "assignment_id": assignment_id
      }
    });
    return data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'syncing to canvas',
                error,
                module: 'CANVAS',
                operation: 'SET_TEACHER_CLASS'
            });
    }
    return {}
  }
}
export const handleSyncFromCanvas = async (canvas_user_id, auth_id, assignment_id) => {
  try {
    const data = await apis.post('canvas', `/sync_assignment_grade_from_canvas`, {
      body: {
        "canvas_user_id": canvas_user_id,
        "auth_id": auth_id,
        "assignment_id": assignment_id
      }
    });
    return data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'syncing from canvas',
                error,
                module: 'CANVAS',
                operation: 'SET_FEEDBACK_CONTENT'
            });
    }
    return {}
  }
}
export const handleGetCanvasCourseByUser = async (canvas_id, auth_id, isTeacher) => {
  try {
    const data = await apis.post('canvas', `/getCourseByUser`, {
      body: {
        canvas_id,
        "auth_id": auth_id,
        isTeacher
      }
    });
    return data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: '801-b Error getting canvas course by user',
                error,
                module: 'CANVAS',
                operation: 'EXPORT_GRADE_CLASS_CLASS_BOOK_USER'
            });
    }
    return {}
  }
}
export const handleSyncCanvasClass =  (canvas_id, auth_id, courseInfo,currentUser) => async dispatch => {
  try {
    const data = await apis.post('canvas', `/syncClass`, {
      body: {
        canvas_id,
        auth_id,
        courseInfo
      }
    });
    if(data && data.success){
     await dispatch(handleListUserClasses(currentUser.id));
    }
    return data;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'syncing canvas class',
                error,
                module: 'CANVAS',
                operation: 'SET_CLASS_CLASS'
            });
    }
    return {}
  }
}

export const handleGetCanvasCoursesByWorkflowState = async (canvas_id, auth_id, workflow_state) => {
  try {
    const data = await apis.post('canvas', `/getCoursesByWorkflowState`, {
      body: {
        canvas_id,
        auth_id,
        workflow_state
      }
    });
    
    // Handle the response structure: { status_code, data, data_type, success, message }
    if (data && data.success && data.data) {
      return data; // Return the full response object
    } else {
      return { 
        status_code: 400, 
        data: [], 
        data_type: 'array', 
        success: false, 
        message: 'No courses found or invalid response' 
      };
    }
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'getting canvas courses by workflow state',
                error,
                module: 'CANVAS',
                operation: 'GET_CLASS_CLASS_BOOK_WORKSHEET_STUDENT'
            });
    }
    return { 
      status_code: 500, 
      data: [], 
      data_type: 'array', 
      success: false, 
      message: 'Error fetching courses', 
      error: error.message 
    };
  }
}
